import { OrganizationProfileApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const organizationProfileApi = new OrganizationProfileApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
